import React, { useState, useEffect, Fragment } from "react";

interface IPagingDetails {
  pageSize: number;
  totalRecords: number;
  pageNumber: number;
}

export const PagingDetailsLabel = (props: IPagingDetails) => {
  const [startRecord, setStartRecord] = useState<number>(1);
  const [endRecord, setEndRecord] = useState<number>(1);

  useEffect(() => {
    const start = (props.pageNumber - 1) * props.pageSize + 1;
    const end = Math.min(props.pageNumber * props.pageSize, props.totalRecords);
    setStartRecord(start);
    setEndRecord(end);
  }, [props]);

  return (
    <>
      {`Showing ${startRecord} to ${endRecord} of ${props.totalRecords} results`}
    </>
  );
};
